<template>
  <v-main>

    <v-container
        id="users-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-account-multiple-outline"
          class="px-5 py-5"
      >
        <v-card-text v-if="errors.length">
          <v-alert color="error"
                   dark
                   outlined
                   :key="error.id"
                   show variant="danger"
                   v-for="error in errors">
            {{ error }}
          </v-alert>
        </v-card-text>

        <v-card-text>
          <v-card-title>
            <v-row>
              <v-col>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col class="text-right">
                <div class="my-2">
                  <vue-csv-downloader
                      :data="csvData"
                      download-name="TilyetMembersExport.csv"
                  >
                    <v-btn
                        color="primary"
                    >
                      Download CSV
                    </v-btn>
                  </vue-csv-downloader>
                </div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
              :headers="headers"
              :items="users"
              :search="search"
              :items-per-page="25"
              class="elevation-1"
              dense
              loading-text="Loading... Please wait"
          >

            <template #item.firstName="{ item }">
              <router-link :to="{ name: 'view_member', params: {memberId: item.id} }">
                {{ item.firstName }}
              </router-link>
            </template>
            <template #item.middleName="{ item }">
              <router-link :to="{ name: 'view_member', params: {memberId: item.id} }">
                {{ item.middleName }}
              </router-link>
            </template>
            <template #item.lastName="{ item }">
              <router-link :to="{ name: 'view_member', params: {memberId: item.id} }">
                {{ item.lastName }}
              </router-link>
            </template>

            <template #item.location="{ item }">{{ item.city }}, {{ item.state }}</template>
            <template #item.status="{ item }">{{ userStatusMap[item.status] }}</template>

          </v-data-table>


        </v-card-text>


      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import VueCsvDownloader from 'vue-csv-downloader'
import api from '@/services/api'
import constants from '@/utils/constants'

export default {
  name: 'CoreMembersView',

  components: {
    VueCsvDownloader
  },

  created() {
    this.fetchMembers()
  },

  computed: {
    csvData: function () {
      return this.users.map((user) => {
        return  {
          accountNum: user.accountNumber,
          firstName: user.firstName,
          middleName: user.middleName,
          lastName: user.lastName,
          emailAddress: user.email,
          phoneNumber: user.phoneNumber,
          city: user.city,
          state: user.state,
          joinedOn: new Date(user.joined).toLocaleDateString(),
          lastUpdated: (user.updated !== null) ? new Date(user.updated).toLocaleString() : "",
          status: this.userStatusMap[user.status],
        }
      })
    }
  },

  methods: {
    fetchMembers() {
      api.fetchUsers().then(response => {
        this.users = response.data
      }).catch(err => {
        this.handleError(err)
      })
    },
    handleError(err) {
      let errorMessage = api.parseResponseError(err, true)
      this.errors.push(errorMessage)
    }
  },

  data() {
    return {
      search: '',
      headers: [
        {
          text: 'First Name',
          value: 'firstName'
        },
        {
          text: 'Middle Name',
          value: 'middleName'
        },{
          text: 'Last Name',
          value: 'lastName'
        },
        {
          text: 'Location',
          value: 'location'
        },
        {
          text: 'Phone Number',
          value: 'phoneNumber'
        },
        {
          text: 'Status',
          value: 'status'
        }
      ],
      users: [],
      errors: [],
      userStatusMap: constants.getUserStatusMap()
    }
  }
}
</script>
